/*
  订单类型标识  orderTypeFlag 1：计划订单 2：权益券核销订单 3：轮胎订单 4.优惠券核销订单 6.保养套餐 7.礼包 9.NEV 10.易损件 101 延保订单
  退款状态标识 refundStatusFlag{ 1：待经销商确认 2：经销商已确认退款（退款中） 3：超时自动退款（退款中） 4：退款成功  5：退款失败  6:客户撤销退款 7:退款成功（线下退款） }
  订单状态标识 orderStatusFlag{ 1：待支付 2：已取消（客户取消/超时自动取消） 3：待接单 4：申请退款 5：已拒单 6：已接单，待评价 7：已评价 8：已作废 9：已完成
  核销状态标识 vertificationStatusFlag  1订单待支付，2待上传凭证， 3待审核凭证 ，4审核通过， 5审核不通过 ，6放弃核销
*/
export const EWOrderTypeFlag = 101
export const EWCouponType = 101

// 售后按钮
const afterSalesBtn = {
  text: '售后',
  btnId: '5',
  fn: 'afterSales',
  dialogConfig: {
    content: '确定拨打经销商电话？',
    confirmButtonText: '确认拨打',
    cancelButtonText: '暂不拨打'
  }
}

// 取消订单
export const cancelOrderBtn = {
  text: '取消订单',
  fn: 'cancelOrder',
  btnId: '1',
  dialogConfig: {
    content: '确定取消订单？',
    confirmButtonText: '确认取消',
    cancelButtonText: '暂不取消'
  },
  param: { statusFlag: 1 }
}

// 申请退款
export const applyRefundBtn = {
  text: '申请退款',
  fn: 'applyRefund',
  btnId: '3',
  dialogConfig: {
    content: '确定申请退款？',
    confirmButtonText: '确认退款',
    cancelButtonText: '取消'
  },
  type: 'active',
  param: { statusFlag: 2 }
}
// 服务订单申请退款
export const applyServiceRefundBtn = {
  text: '申请退款',
  btnId: '91',
  type: 'active',
  fn: 'dealServiceOrderRefund',
  dialogConfig: {
    content: '确定申请退款？</br>需等待经销商同意退款后，才可退款成功',
    confirmButtonText: '确认退款',
    cancelButtonText: '取消'
  },
  param: { serviceOrderId: '', refundStatusFlag: 1 }
}

// 撤销退款
const cancelRefundBtn = {
  text: '撤销退款',
  fn: 'cancelRefund',
  btnId: '4',
  dialogConfig: {
    content: '确定撤销退款？',
    confirmButtonText: '确认撤销',
    cancelButtonText: '取消'
  },
  type: 'active',
  param: { statusFlag: 3 }
}
// 服务订单撤销退款
export const cancelServiceRefundBtn = {
  text: '撤销退款',
  btnId: '92',
  type: 'active',
  fn: 'dealServiceOrderRefund',
  dialogConfig: {
    content: '确定撤销退款？</br>撤销退款后经销商可正常备货',
    confirmButtonText: '确认撤销',
    cancelButtonText: '取消'
  },
  param: { serviceOrderId: '', refundStatusFlag: 6 }
}
// 确认完成
export const sureFinishedBtn = {
  text: '确认完成',
  fn: 'sureFinished',
  btnId: '88',
  dialogConfig: {
    content: '确定本订单的轮胎服务已完成？',
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  },
  type: 'active',
  param: { statusFlag: 4 }
}

// 激活服务合约
export const sureActiveBtn = {
  text: '激活',
  fn: 'sureFinished',
  btnId: '89',
  dialogConfig: {
    content: '确认激活？',
    confirmButtonText: '确认激活',
    cancelButtonText: '取消'
  },
  type: 'active',
  param: { statusFlag: 5 }
}

const payNow = { text: '立即支付', btnId: '2', type: 'active' }
// const toComment = { text: '去评价', btnId: '6', type: 'active' }
// const seeComment = { text: '查看评价', btnId: '8', type: 'active' }
export const creatOabBtn = { text: '立即预约', btnId: '11', type: 'active' }
export const viewOabBtn = { text: '查看预约', btnId: '12', type: 'active' }

// 计划订单状态
const planStatusConf = {
  '1': {
    en: 'awaitPay',
    zh: '待支付',
    icon: 'pending-payment',
    // 显示倒计时
    showCountDown: true
  },
  '2': {
    // （超时自动取消/客户取消/）
    // 此处配置-超时自动取消
    en: 'alreadyCancel',
    zh: '交易关闭',
    icon: 'close',
    statusDesc: '交易关闭',
    // 显示删除小图标
    showDeleteIcon: true
  },
  '3': {
    en: 'awaitAccept',
    zh: '待接单',
    icon: 'underway-o'
  },
  '4': {
    en: 'applyRefund',
    zh: '申请退款'
  },
  '5': {
    en: 'alreadyRefuse',
    zh: '已拒单',
    icon: 'close',
    statusDesc: '接单失败'
  },
  '6': {
    // 已接单，待评价
    en: 'alreadyAccept',
    zh: '已接单',
    icon: 'passed',
    statusDesc: '已接单并核实车辆信息，去使用权益'
  },
  '7': {
    en: 'alreadyComment',
    zh: '已评价',
    icon: 'passed'
  },
  '8': {
    en: 'alreadyObsolete',
    zh: '已作废',
    icon: 'close',
    showDeleteIcon: true
  },
  '41': {
    //待接单-申请退款-待确认
    en: 'awaitSureRefund',
    zh: '申请退款中,待经销商确认',
    icon: 'underway-o'
  },
  '42': {
    //经销商已确认退款（退款中）
    en: 'delRefunding',
    zh: '经销商已确认退款,退款中',
    icon: 'underway-o'
  },
  '43': {
    //超时自动退款（退款中）
    en: 'autoRefunding',
    zh: '超时自动退款,退款中',
    icon: 'underway-o',
    statusDesc: '超时系统自动发起退款'
  },
  '44': {
    //申请退款成功
    en: 'refundSuccess',
    zh: '退款成功',
    icon: 'passed',
    showDeleteIcon: true
  },
  '45': {
    //退款失败
    en: 'refundFaile',
    zh: '退款失败',
    icon: 'close'
  },
  '52': {
    //拒单（退款中）
    en: 'autoRefunding',
    zh: '经销商取消订单，退款中',
    icon: 'underway-o',
    statusDesc: '经销商取消订单，已发起退款'
  },
  '54': {
    //拒单退款成功
    en: 'refundSuccess',
    zh: '经销商取消订单，退款成功',
    icon: 'passed',
    showDeleteIcon: true
  },
  '55': {
    //拒单退款失败
    en: 'refundFaile',
    zh: '经销商取消订单，退款失败',
    icon: 'close'
  }
}

// 核销订单状态
const verifyStatusConf = {
  '1': {
    en: 'awaitPay',
    zh: '待支付',
    icon: 'pending-payment',
    showCountDown: true
  },
  '2': {
    // （超时自动取消/客户取消/）
    // 此处配置-超时自动取消
    en: 'alreadyCancel',
    zh: '交易关闭',
    icon: 'close',
    statusDesc: '交易关闭',
    showDeleteIcon: true
  },
  // 已线下支付/待完成
  '3': {
    en: 'alreadyPay',
    zh: '已线下支付',
    icon: 'underway-o'
  },
  // 已线下退款
  '4': {
    en: 'alreadyRefund',
    zh: '已线下退款',
    icon: 'close',
    showDeleteIcon: true
  },
  // 待完成
  '5': {
    en: 'awaitFinished',
    zh: '待完成',
    icon: 'passed'
  },
  // 已完成/待评价
  '6': {
    en: 'awaitComment',
    zh: '已完成',
    icon: 'passed',
    showDeleteIcon: true
  },
  // 已评价
  '7': {
    en: 'alreadyComment',
    zh: '已评价',
    icon: 'passed',
    statusDesc: '已完成',
    showDeleteIcon: true
  },

  '8': {
    //退款中
    en: 'inRefunding',
    zh: '退款中',
    icon: 'underway-o'
  },
  '9': {
    //退款成功
    en: 'refundSuccess',
    zh: '退款成功',
    icon: 'passed',
    showDeleteIcon: true
  }
}

// 轮胎订单状态
const tyreStatusConf = {
  '1': {
    en: 'awaitPay',
    zh: '待支付',
    icon: 'pending-payment',
    showCountDown: true
  },
  '2': {
    en: 'awaitScan',
    zh: '待扫码确认',
    icon: 'scan',
    statusDesc: '待扫码确认'
  },
  '3': {
    en: 'closeOrder',
    zh: '交易关闭',
    icon: 'close',
    statusDesc: '交易关闭'
    // showDeleteIcon: true
  },
  '4': {
    // 已取消
    en: 'alreadyCancel',
    zh: '已取消',
    icon: 'close',
    statusDesc: '已取消',
    showDeleteIcon: true
  },
  // 已支付
  // "3": {
  //   en: "alreadyPay",
  //   zh: "已支付",
  //   icon: "underway-o"
  // },

  // 待完成
  '5': {
    en: 'awaitFinished',
    zh: '待完成',
    icon: 'passed'
  },
  // 已完成
  '6': {
    en: 'alreadyFinished',
    zh: '已完成',
    statusDesc: '已完成',
    icon: 'passed'
  },
  '7': {
    //申请退款-待确认
    en: 'awaitSureRefund',
    zh: '退款待确认',
    icon: 'underway-o'
  },
  '8': {
    //退款中
    en: 'inRefunding',
    zh: '退款中',
    icon: 'underway-o'
  },
  '9': {
    //退款成功
    en: 'refundSuccess',
    zh: '退款成功',
    icon: 'passed'
    // showDeleteIcon: true
  }
}
// 服务合约订单状态
// 待支付 1【取消+付款】
//已取消 2 【无】
//待激活/待完成 3 【激活+退款】
//已激活/已完成 9 【无】
//退款中（含超时情况）4
//订单关闭(已退款) 13
//已退货 14

const shopStatusConf = {
  '1': {
    en: 'awaitPay',
    zh: '待支付',
    icon: 'pending-payment',
    showCountDown: true
  },
  '2': {
    // 已取消
    en: 'alreadyCancel',
    zh: '已取消',
    icon: 'close',
    statusDesc: '已取消',
    showDeleteIcon: true
  },
  // 待激活
  '3': {
    en: 'awaitActivat',
    zh: '待激活',
    icon: 'underway-o'
  },
  '4': {
    //退款中
    en: 'inRefunding',
    zh: '退款中',
    icon: 'underway-o'
  },

  // 已激活
  '9': {
    en: 'activation',
    zh: '已激活',
    statusDesc: '已激活，请到我的卡券中使用',
    icon: 'passed'
  },
  //订单关闭(已退款)
  '13': {
    en: 'alreadyClose',
    zh: '已退款',
    icon: 'close'
    // showDeleteIcon: true
  },
  '14': {
    en: 'refundSuccess',
    zh: '已退款', //LPO-12565 服务合约已退货的订单和卡券显示为已退款
    icon: 'close'
    // showDeleteIcon: true
  }
}

// 致友计划订单按钮
const planBtnObj = {
  //等待支付
  awaitPay: [cancelOrderBtn, payNow],
  // 待接单
  awaitAccept: [applyRefundBtn],
  //待接单-申请退款-待确认
  awaitSureRefund: [cancelRefundBtn],

  // 经销商已确认退款
  delRefunding: [afterSalesBtn],
  // 拒单、超时-退款中
  autoRefunding: [afterSalesBtn],
  //已接单
  alreadyAccept: [],
  // 退款成功
  refundSuccess: [afterSalesBtn],
  refundFaile: [afterSalesBtn],
  //已评价
  alreadyComment: [],
  //已作废
  alreadyObsolete: [afterSalesBtn]
}

// 核销订单按钮
const verifyBtnObj = {
  //等待支付
  awaitPay: [cancelOrderBtn, payNow],
  //已评价
  alreadyComment: [],
  // 待评价
  awaitComment: []
}

// 轮胎订单按钮
const tyreBtnObj = {
  //等待支付
  awaitPay: [payNow],
  // 待扫码确认
  awaitScan: [Object.assign({}, cancelOrderBtn, { fn: '' })],
  // 申请退款-待确认
  awaitSureRefund: [cancelRefundBtn],
  // 待评价
  awaitComment: [],
  //已评价
  alreadyComment: []
}

const shopBtnObj = {
  //等待支付
  awaitPay: [payNow, Object.assign({}, cancelOrderBtn, { fn: '' })],
  awaitActivat: [sureActiveBtn]
}

export default {
  planStatusConf,
  verifyStatusConf,
  tyreStatusConf,
  shopStatusConf,
  planBtnObj,
  verifyBtnObj,
  tyreBtnObj,
  shopBtnObj
}
